'use strict';

const $ = require('jquery');

const moment = require('moment');

const forEach = require('lodash/forEach');
const map = require('lodash/map');

const SELECTORS = {
    AUDIOPLAYER: '.js-audio-player',
    PLAYLIST: '.js-playlist-item',
    VOLUME: '.js-volume-bar',
    MUTE: '.js-mute-control',
    PLAYBUTTON: '.js-playPauseAudio',
    PREVBUTTON: '.js-prevAudio',
    NEXTBUTTON: '.js-nextAudio',
    COUNTPLAYBACKELEMENT: '.js-countPlaybackElement',
    PROGRESSBAR: '.js-audio-gallery__progress',
    PROGRESSTRACK: '.js-update-progress'
};

const CSS_CLASSES = {
    ACTIVE_ITEM: 'is-active',
    PAUSED: 'is-paused',
    PLAYING: 'is-playing'
};

const CSS_VOLUME_CLASSES = ['mute', 'volume1', 'volume2', 'volume3'];

let audio = {
    player : undefined,
    items : undefined,
    playlist: undefined,
    itemDuration: undefined
};

let controls = {
    playPauseBtn : undefined,
    nextBtn : undefined,
    prevBtn : undefined,
    mute: undefined
};

let state = {
    playing: false,
    currentPosition: 0,
    totalLength: 0,
    muted: false,
    currentVolume: 0.5
};

let progressBar = {
    container: undefined,
    track: undefined,
    trackWidth: 0,
    increment: 0
};

let countPlaybackInterval, dragging = false;

function init () {
    let playerEl = document.querySelector(SELECTORS.AUDIOPLAYER);

    if (!playerEl) {
        return false;
    }

    audio.player = playerEl;
    audio.playlist = $(SELECTORS.PLAYLIST);
    audio.countPlaybackElement = $(SELECTORS.COUNTPLAYBACKELEMENT);

    audio.items = map(audio.playlist, item => {
        return $(item).attr('data-src');
    });

    controls.playPauseBtn = document.querySelector(SELECTORS.PLAYBUTTON);
    controls.prevBtn = document.querySelector(SELECTORS.PREVBUTTON);
    controls.nextBtn = document.querySelector(SELECTORS.NEXTBUTTON);
    controls.volume = document.querySelector(SELECTORS.VOLUME);
    controls.mute = document.querySelector(SELECTORS.MUTE);

    progressBar.container = $(SELECTORS.PROGRESSBAR);
    progressBar.track = $(SELECTORS.PROGRESSTRACK);

    state.totalLength = audio.items.length;

    audio.player.volume = 0.5;

    loadAudio();
    resetCountPlayback();
    setEventHandlers();
}

function loadAudio() {
    audio.player.pause();
    state.playing = false;

    $(controls.playPauseBtn).removeClass(CSS_CLASSES.PLAYING);

    audio.player.src = audio.items[state.currentPosition];

    resetCountPlayback();
    hightlightCurrentPlaylistItem();
    setTrackProgress();
}

function resetCountPlayback() {
    stopCountPlayback();

    audio.countPlaybackElement.html(formatCountPlayback(0));
}

function stopCountPlayback() {
    window.clearInterval(countPlaybackInterval);
}

function formatCountPlayback(time) {
    var date = new Date(null);
    date.setSeconds(time); // specify value for SECONDS here

    // TODO: Do we need to use moment here?
    return moment.parseZone(date).format('mm:ss');
}

function hightlightCurrentPlaylistItem() {
    forEach(audio.playlist, element => {
        $(element).removeClass(CSS_CLASSES.ACTIVE_ITEM);
    });

    $(audio.playlist[state.currentPosition]).addClass(CSS_CLASSES.ACTIVE_ITEM);
}

function setTrackProgress() {
    progressBar.track.width(getTrackPercentage() + '%');
}

function getTrackPercentage() {
    return (audio.player.currentTime / audio.itemDuration) * 100;
}

function setEventHandlers() {
    audio.player.addEventListener('canplaythrough', e => {
        e.preventDefault();

        audio.itemDuration = e.currentTarget.duration;
    });

    audio.player.addEventListener('ended', e => {
        e.preventDefault();

        resetCountPlayback();
        nextAudio();

        // So it doesn't loop
        if (state.currentPosition) {
            playPauseAudio();
        }
    });

    $(progressBar.container).on('mousedown', e => {
        e.preventDefault();

        dragging = true;
    });

    $(progressBar.container).on('mousemove', e => {
        e.preventDefault();

        if (!dragging) {
            return false;
        }

        audio.player.currentTime = setTrackPosition(e.offsetX);

        setTrackProgress();
    });

    $(progressBar.container).on('mouseup', e => {
        e.preventDefault();

        audio.player.currentTime = setTrackPosition(e.offsetX);

        setTrackProgress();

        dragging = false;
    });

    $(controls.playPauseBtn).on('click', e => {
        e.preventDefault();

        playPauseAudio();
    });

    $(controls.prevBtn).on('click', e => {
        e.preventDefault();

        prevAudio();
        playPauseAudio();
    });

    $(controls.nextBtn).on('click', e => {
        e.preventDefault();

        nextAudio();
        playPauseAudio();
    });

    $(controls.volume).on('input', e => {
        e.preventDefault();

        state.muted = false;

        var volume = $(e.target).val();

        audio.player.volume = volume;
        state.currentVolume = volume;

        setVolumeCSSClass();
    });

    $(controls.volume).on('change', e => {
        e.preventDefault();

        setVolumeCSSClass();
    });

    $(controls.mute).on('click', e => {
        e.preventDefault();

        muteAudio();
    });


    forEach(audio.playlist, (element, i) => {
        $(element).on('click', () => {
            state.currentPosition = i;

            loadAudio();
            playPauseAudio();
        });
    });
}

function nextAudio() {
    var nextPos = ++state.currentPosition;

    if (nextPos >= state.totalLength) {
        state.currentPosition = 0;
    } else {
        state.currentPosition = nextPos;
    }

    loadAudio();
}

function playPauseAudio() {
    if (!state.playing) {
        $(controls.playPauseBtn).addClass(CSS_CLASSES.PLAYING);

        audio.player.play();

        startCountPlayback();
    } else {
        $(controls.playPauseBtn).removeClass(CSS_CLASSES.PLAYING);

        audio.player.pause();

        stopCountPlayback();
    }

    state.playing = !state.playing;
}

function startCountPlayback() {
    countPlaybackInterval = window.setInterval(() => {
        audio.countPlaybackElement.html(
            formatCountPlayback(audio.player.currentTime)
        );

        setTrackProgress();
    }, 10);
}

function setTrackPosition(xPos) {
    return parseInt((( xPos / $(progressBar.container).width() ) * 100 / 100 ) * audio.itemDuration, 10);
}

function prevAudio() {
    if (audio.player.currentTime > 3) {
        audio.player.currentTime = 0;

        stopAudio();

        audio.countPlaybackElement.html(
            formatCountPlayback(audio.player.currentTime)
        );

        setTrackProgress();

        return false;
    }

    var prevPos = --state.currentPosition;

    if (prevPos < 0) {
        state.currentPosition = state.totalLength - 1;
    } else {
        state.currentPosition = prevPos;
    }

    loadAudio();
}

function stopAudio() {
    state.playing = false;

    audio.player.pause();
}

function setVolumeCSSClass() {
    forEach(CSS_VOLUME_CLASSES, cssClass => {
        $(controls.mute).removeClass(cssClass);
    });

    if (state.currentVolume <= 0) {
        $(controls.mute).addClass(CSS_VOLUME_CLASSES[0]);
    } else if (state.currentVolume <= 0.3) {
        $(controls.mute).addClass(CSS_VOLUME_CLASSES[1]);
    } else if (state.currentVolume <= 0.6) {
        $(controls.mute).addClass(CSS_VOLUME_CLASSES[2]);
    } else {
        $(controls.mute).addClass(CSS_VOLUME_CLASSES[3]);
    }
}

function muteAudio() {
    if (!state.muted) {
        audio.player.volume = 0;
        state.currentVolume = 0;
        $(controls.volume).val(0);
    } else {
        audio.player.volume = state.currentVolume;
    }

    setVolumeCSSClass();

    state.muted = !state.muted;
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./modules/audioPlayer.js